import LocationIcon from "./marker-pin-04.svg";
import Smoke from "./smoke.svg";
import Phone from "./phone.svg";
import ChevronLeft from "./chevron-left.svg";
import ChevronRight from "./chevron-right.svg";
import OnsenIcon from "./onsen.svg";
import WiFiIcon from "./wifi.svg";
import ChargeIcon from "./charge.svg";
import AngleRightSmall from "./angle-right-small.svg";
import AngleLeftSmall from "./angle-left-small.svg";
import BathTub from "./bath-tub.svg";
import Expand from "./expand.svg";
import DoubleBed from "./double-bed.svg";
import ParkingSpaces from "./parkingSpaces.svg";
import User from "./user.svg";
import Toilet from "./toilet.svg";
import SwimmingPool from "./swimming-pool.svg";
import InfoCircle from "./info-circle.svg";
import AngleDownSmall from "./angle-down-small.svg";
import Spinner from "./spinner.svg";
import Filter from "./filterIcon.svg";
import Location from "./location.svg";
import BathtubType from "./bathtub-type.svg";
import ToiletType from "./toilet-type.svg";
import ShowerType from "./shower-type.svg";
import Cloud from "./cloud.svg";
import Map from "./map.svg";
import Letter from "./letter.svg";
import EmailIcon from "./emailIcon.svg";
import CircleDownIcon from "./CircleDownIcon.svg";
import MapSearch from "./map-search.svg";
import CircleNext from "./circle-next.svg";
import CloseIcon from "./close.svg";
import WhiteCircleNext from "./white-circle-next.svg";
import CircleDown from "./circle-down.svg";
import PhoneSpriteIcon from "./sprite-phone.svg";
import EmailSpriteIcon from "./sprite-mail.svg";
import WebSpriteIcon from "./sprite-icon-web.svg";
import ChatSpriteIcon from "./sprite-chat.svg";
import ArrowDownSpriteIcon from "./arrow-down-sprite.svg";
import SliderNext from "./slider-next.svg";
import SliderPrev from "./slider-prev.svg";
import PhotosIcon from "./photos-icon.svg";
import FullScreenIcon from "./full-screen-icon.svg";
import FacebookBlack from "./facebook-black.svg";
import YoutubeBlack from "./youtube-black.svg";
import LINEBlack from "./line-black.svg";
import InstagramBlack from "./instagram-black.svg";
import XBlack from "./x-black.svg";
import Adjust from "./adjust.svg";
import Point1 from "./point-1.svg";
import Point2 from "./point-2.svg";
import Point3 from "./point-3.svg";
import Room from "./room.svg";
import DropDown from "./drop-down.svg";

export const iconList = {
  locationIcon: LocationIcon,
  smoke: Smoke,
  phone: Phone,
  ChevronLeft,
  ChevronRight,
  OnsenIcon,
  WiFiIcon,
  ChargeIcon,
  AngleRightSmall,
  AngleLeftSmall,
  AngleDownSmall,
  BathTub,
  Expand,
  DoubleBed,
  ParkingSpaces,
  User,
  Toilet,
  SwimmingPool,
  Spinner,
  InfoCircle,
  Filter,
  Location,
  ToiletType,
  ShowerType,
  Cloud,
  Map,
  MapSearch,
  BathtubType,
  Letter,
  EmailIcon,
  CircleDownIcon,
  CircleNext,
  CloseIcon,
  WhiteCircleNext,
  CircleDown,
  PhoneSpriteIcon,
  EmailSpriteIcon,
  WebSpriteIcon,
  ChatSpriteIcon,
  ArrowDownSpriteIcon,
  SliderNext,
  SliderPrev,
  PhotosIcon,
  FullScreenIcon,
  FacebookBlack,
  InstagramBlack,
  XBlack,
  YoutubeBlack,
  LINEBlack,
  Adjust,
  Point1,
  Point2,
  Point3,
  Room,
  DropDown,
};
